/**
 * Auth API service
 * Centralized API calls for authentication
 * @module features/auth/authService
 */

import api from '../../app/axios';

const AUTH_REQUEST_TIMEOUT = 15000;

const register = async (userData) => {
  const response = await api.post('/auth/register', userData, {
    timeout: AUTH_REQUEST_TIMEOUT,
  });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response.data;
};

const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials, {
    timeout: AUTH_REQUEST_TIMEOUT,
  });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response.data;
};

const logout = async () => {
  await api.post('/auth/logout');
  localStorage.removeItem('token');
};

const getMe = async () => {
  const response = await api.get('/auth/me', {
    timeout: AUTH_REQUEST_TIMEOUT,
  });
  return response.data;
};

const updateProfile = async (profileData) => {
  const response = await api.put('/auth/profile', profileData);
  return response.data;
};

const changePassword = async (passwordData) => {
  const response = await api.put('/auth/change-password', passwordData);
  return response.data;
};

const requestPasswordReset = async (identity) => {
  const response = await api.post('/auth/forgot-password', { identity });
  return response.data;
};

const resetPassword = async (token, passwordData) => {
  const response = await api.post(`/auth/reset-password/${token}`, passwordData);
  return response.data;
};

const deactivateAccount = async (password, reason) => {
  const response = await api.post('/auth/deactivate', { password, reason });
  localStorage.removeItem('token');
  return response.data;
};

const authService = {
  register,
  login,
  logout,
  getMe,
  updateProfile,
  changePassword,
  requestPasswordReset,
  resetPassword,
  deactivateAccount,
};
export default authService;

// Developed and Designed by Trophy Developers
